"use client";

import { FixedSkeleton } from "@components";
import { debounce } from "lodash-es";
import React, { FC, memo, useEffect, useState } from "react";

import { useChartStore } from "../../chart.state";
import { generateOptions } from "./constnats";
import { useEcharts, useWorker } from "./hooks";

export type InvestmentChartProps = {
  inflation?: number; // 通胀(单位%)
  origin?: number; // 初始定投金额
  prepayment?: number; // 预付款
  profit?: number; // 年化(单位%)
  profitSpan?: number; // 结算周期
  viewTime?: number; // 查看时间(单位:day)
};

const Main: FC = () => {
  const { formValues } = useChartStore();
  const { chartInstance, chartRef } = useEcharts();
  const [loading, setLoading] = useState(true);
  const worker = useWorker();

  useEffect(() => {
    setLoading(true);
    /** 计算 options */
    const setChartOption = async () => {
      const params: InvestmentChartProps = {
        inflation: formValues?.inflation,
        origin: formValues?.money,
        prepayment: formValues?.prepayment,
        profit: formValues?.profit,
        profitSpan: Number(formValues?.timespanValue),
        viewTime: Number(formValues?.viewspanValue),
      };
      const handleData = await worker?.calculateData(params);
      if (!handleData) return;
      const options = generateOptions(handleData);
      chartInstance?.setOption(options);
      setLoading(false);
    };
    setChartOption();
  }, [chartInstance, formValues, worker]);

  useEffect(() => {
    const element = chartRef.current?.parentElement;
    if (element) {
      const delay = 300; // ms
      const handleResize = () => {
        chartInstance?.resize();
        setLoading(false);
      };
      const resizeObserver = new ResizeObserver(debounce(handleResize, delay));
      const loadingObserver = new ResizeObserver(() => setLoading(true));
      resizeObserver.observe(element);
      loadingObserver.observe(element);
      return () => {
        resizeObserver.disconnect();
        loadingObserver.disconnect();
      };
    }
  }, [chartInstance, chartRef]);

  return (
    <div className="relative flex size-full flex-1">
      <div className="size-full" ref={chartRef} />
      {(!chartInstance || loading) && (
        <div className="absolute size-full">
          <FixedSkeleton />
        </div>
      )}
    </div>
  );
};

export const InvestmentChart = memo(Main);
